export enum TournamentStatus {
    CREATED = 'CREATED',
    OPENED = 'OPENED',
    FINISHED = 'FINISHED',
    CANCELED = 'CANCELED',
}
